var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wysiwyg-editor',{staticClass:"is-padding-xsmall wysiwygEditor--noteLeads",attrs:{"model":_vm.note,"light":true,"tooltip-top":true,"fromQuickview":true},on:{"change":function (val) { return _vm.note = val; }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78500c83","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/quickview/NewNote.vue
// module id = null
// module chunks = 